import { Injectable } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { of, throwError } from 'rxjs';
import { switchMap, tap, catchError } from 'rxjs/operators';
import { ERefreshTokenActions, RefreshToken, RefreshTokenSuccess } from '../actions/refresh-token.actions';
import { LoginService } from '../../services/login.service';
import { TokenLocalStorageService } from '../../services/token-local-storage.service';
import { LoginResponseInterface } from '../../models/login-response.interface';
import { Store } from '@ngrx/store';
import { AbstractEffects } from '../../../shared/abstract.effects';
import { DeleteToken } from '../actions/login.actions';

@Injectable()
export class RefreshTokenEffects extends AbstractEffects {

    constructor(
        private loginService: LoginService,
        private localStorageService: TokenLocalStorageService,
        private actions: Actions,
        public override store: Store<any>
    ) {
        super(store);
    }

    getRefreshToken = createEffect(() => this.actions.pipe(
        ofType<RefreshToken>(ERefreshTokenActions.RefreshToken),
        switchMap(() => this.loginService.refreshToken()),
        switchMap((response: LoginResponseInterface) => of(new RefreshTokenSuccess(response))),
        tap(action => { this.localStorageService.save(action.payload, false); }),
        catchError((error) => {
            this.DisplayMessage('error_with_retry', 400, new DeleteToken());
            return throwError(error);
        })
    ));
}
